/* FH-2026-09-26 KLAVIYO POPUP TRIGGER START */
/*
 * Fab Habitat - hidden custom-code trigger for the Klaviyo newsletter popup (A2 full-screen).
 * Approved by Suchin 2026-09-26. Replaces the fh-klaviyo-teaser pill.
 * The Klaviyo form must be set to "Only show on custom trigger" (no delay/scroll/exit triggers),
 * because Klaviyo opens a form on whichever trigger fires first.
 * Rules:
 *  1. Wait until the Shopify cookie banner is answered (Customer Privacy API + visitorConsentCollected;
 *     falls back to "no banner for this region" and to a DOM check of #shopify-pc__banner).
 *  2. Then open after 5 s OR a scroll to 30% of the page, whichever comes first.
 *  3. Defer while focus is in a text input / textarea / search field (re-check after blur).
 *  4. At most once per browser session; 14 days after a dismissal; never after a signup.
 *  5. Suppress for email-click visitors (_kx or utm_medium=email) and known Klaviyo profiles.
 *  6. Opens with window._klOnsite.push(['openForm', FORM_ID]).
 *  7. Optional a11y safety net (FOCUS_SAFETY_NET): on close, return focus to the element that had it before
 *     the form opened; if that element is hidden/gone (e.g. the cookie banner's Accept button), focus #MainContent.
 */
(function () {
  'use strict';
  if (window.__fhKlPopup) return;

  var FORM_ID = 'TSDUdd';
  var DELAY_MS = 5000;
  var SCROLL_RATIO = 0.3;
  var DISMISS_DAYS = 14;
  var FOCUS_SAFETY_NET = true;       // on: after a cookie-banner answer the prior element is hidden
  var NO_BANNER_WAIT_MS = 4000;      // DOM fallback: banner never appeared -> treat as no banner
  var PRIVACY_API_WAIT_MS = 6000;    // give up on the Customer Privacy API after this
  var K_SESSION = 'fhKlPopupShown';
  var K_DISMISS = 'fhKlPopupDismissedAt';
  var K_SIGNUP = 'fhKlPopupSignedUp';
  var K_EMAIL = 'fhKlPopupEmailVisitor';

  var api = window.__fhKlPopup = { formId: FORM_ID, log: [], state: 'init' };
  function note(s) { api.state = s; api.log.push([Math.round(performance.now()), s]); }

  function ls(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; }
  }
  function ss(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; }
  }

  /* ---------- suppression ---------- */
  function fromEmailClick() {
    try {
      var q = new URLSearchParams(location.search);
      return q.has('_kx') || (q.get('utm_medium') || '').toLowerCase() === 'email';
    } catch (e) { return false; }
  }
  function klaIdentifiedCookie() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (!m) return false;
      var j = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(j && (j.$exchange_id || j.$email || j.$phone_number || j.$kx));
    } catch (e) { return false; }
  }
  function blockedReason() {
    if (ls(K_SIGNUP) === '1') return 'signed-up';
    if (ls(K_EMAIL) === '1') return 'email-visitor';
    if (ss(K_SESSION) === '1') return 'shown-this-session';
    var d = parseInt(ls(K_DISMISS) || '0', 10);
    if (d && Date.now() - d < DISMISS_DAYS * 864e5) return 'dismissed-<14d';
    if (klaIdentifiedCookie()) return 'klaviyo-identified';
    return '';
  }

  /* ---------- Klaviyo form events ---------- */
  var lastFocus = null;
  var openedByUs = false;
  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (!d || String(d.formId) !== FORM_ID) return;
    if (d.type === 'open') { ss(K_SESSION, '1'); note('klaviyo-open'); }
    else if (d.type === 'submit' || d.type === 'stepSubmit') { ls(K_SIGNUP, '1'); note('klaviyo-' + d.type); }
    else if (d.type === 'close') {
      if (ls(K_SIGNUP) !== '1') ls(K_DISMISS, String(Date.now()));
      note('klaviyo-close');
      restoreFocus();
    }
  });

  function usable(el) {
    return !!(el && el !== document.body && document.contains(el) && el.getClientRects().length &&
      !el.closest('#shopify-pc__banner, [aria-hidden="true"], [inert]'));
  }
  function restoreFocus() {
    if (!FOCUS_SAFETY_NET || !openedByUs) return;
    // prior element still usable -> make sure focus is back on it; if it is gone/hidden (typically the cookie
    // banner's Accept button, hidden since), send focus to the top of the main content instead of a random link
    var target = usable(lastFocus) ? lastFocus : document.getElementById('MainContent');
    if (!target) return;
    [150, 450].forEach(function (ms) {
      setTimeout(function () {
        if (document.activeElement === target) return;
        var a = document.activeElement;
        if (target !== lastFocus || !a || a === document.body || !usable(a) ||
            (a.closest && a.closest('[data-kl-scroll-locking-modal], [class*="kl-private-reset-css"], .klaviyo-form'))) {
          try { target.focus({ preventScroll: true }); } catch (x) {}
        }
      }, ms);
    });
  }


  /* ---------- cookie banner gate ---------- */
  function bannerEl() {
    return document.getElementById('shopify-pc__banner') || document.querySelector('.shopify-pc__banner__dialog');
  }
  function bannerVisible() {
    var b = bannerEl();
    if (!b) return false;
    if (b.getAttribute('aria-hidden') === 'true') return false;
    var cs = getComputedStyle(b);
    if (cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = b.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function waitForConsent(done) {
    var fired = false, t0 = Date.now(), sawBanner = false;
    function go(why) { if (fired) return; fired = true; note('consent-ok:' + why); done(); }
    document.addEventListener('visitorConsentCollected', function () { setTimeout(function () { go('event'); }, 300); });

    function checkApi() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.shouldShowBanner !== 'function') return null;
      try {
        if (!cp.shouldShowBanner()) return 'no-banner-region';
        var c = typeof cp.currentVisitorConsent === 'function' ? cp.currentVisitorConsent() : null;
        if (c && ['marketing', 'analytics', 'preferences'].some(function (k) { return c[k] === 'yes' || c[k] === 'no'; })) return 'already-answered';
        var t = typeof cp.getTrackingConsent === 'function' ? cp.getTrackingConsent() : '';
        if (t === 'yes' || t === 'no') return 'already-answered';
        return false; // banner required and not answered yet -> wait for event
      } catch (e) { return null; }
    }
    // NOTE: do NOT call Shopify.loadFeatures('consent-tracking-api') here. The privacy banner already loads the API,
    // and calling it again made Klaviyo's mobile submit take a different (stalling) path in testing on 2026-09-26.
    (function poll() {
      if (fired) return;
      var vis = bannerVisible();
      if (vis) sawBanner = true;
      var r = checkApi();
      if (!vis) {
        if (typeof r === 'string') return go(r);
        if (sawBanner) return go('banner-closed');
        if (r === null && Date.now() - t0 > PRIVACY_API_WAIT_MS) return go('no-api-no-banner');
        if (r === null && Date.now() - t0 > NO_BANNER_WAIT_MS && !bannerEl()) return go('no-banner-dom');
      }
      setTimeout(poll, 250);
    })();
  }

  /* ---------- focus-in-field deferral ---------- */
  function typingField(el) {
    if (!el || el === document.body) return false;
    if (el.isContentEditable) return true;
    var tag = (el.tagName || '').toLowerCase();
    if (tag === 'textarea') return true;
    var role = (el.getAttribute && el.getAttribute('role')) || '';
    if (role === 'searchbox' || role === 'combobox' || role === 'textbox') return true;
    if (tag === 'input') {
      var t = (el.getAttribute('type') || 'text').toLowerCase();
      return ['text', 'search', 'email', 'tel', 'url', 'number', 'password', ''].indexOf(t) !== -1;
    }
    return false;
  }

  /* ---------- open ---------- */
  var armed = false, opening = false;
  function tryOpen(why) {
    if (opening) return;
    var r = blockedReason();
    if (r) { note('blocked:' + r); return; }
    if (bannerVisible()) { note('wait:banner-visible'); setTimeout(function () { tryOpen(why); }, 500); return; }
    var a = document.activeElement;
    if (typingField(a)) {
      note('defer:focus-in-field');
      a.addEventListener('blur', function () { setTimeout(function () { tryOpen(why + '+blur'); }, 400); }, { once: true });
      return;
    }
    opening = true;
    lastFocus = (a && a !== document.body) ? a : null;
    openedByUs = true;
    ss(K_SESSION, '1');
    note('openForm:' + why);
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', FORM_ID]);
  }

  function arm() {
    if (armed) return; armed = true;
    var t = setTimeout(function () { cleanup(); tryOpen('delay'); }, DELAY_MS);
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h >= SCROLL_RATIO) { cleanup(); tryOpen('scroll'); }
    }
    function cleanup() { clearTimeout(t); window.removeEventListener('scroll', onScroll); }
    window.addEventListener('scroll', onScroll, { passive: true });
    note('armed');
  }

  function start() {
    if (fromEmailClick()) { ls(K_EMAIL, '1'); note('blocked:email-click'); return; }
    var r = blockedReason();
    if (r) { note('blocked:' + r); return; }
    var identified = false;
    try {
      if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
        Promise.resolve(window.klaviyo.isIdentified()).then(function (v) { if (v) { identified = true; opening = true; note('blocked:klaviyo-isIdentified'); } }, function () {});
      }
    } catch (e) {}
    waitForConsent(function () { if (!identified) arm(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
/* FH-2026-09-26 KLAVIYO POPUP FULLSCREEN + A11Y START */
/*
 * Layout + a11y fixes for the Klaviyo Full page form (Klaviyo's editor has no overlay/min-height/padding-per-device
 * controls). Scoped ONLY to the dialog that contains form[data-testid="klaviyo-form-<FORM_ID>"].
 *  - opaque Night Gray #404040 backdrop behind the full-page card (never any page showing through)
 *  - form column padding; <=640px: photo column hidden, form fills the screen (fixes 320px reflow + desktop zoom)
 *  - close button: white disc with Night Gray X (the white X sat on the light photo)
 *  - Privacy Policy link underlined (link in text block)
 *  - decorative wave divider image gets alt="" (Klaviyo renders it with no alt attribute)
 *  - Freshchat bubble + Google reviews badge hidden while the form is open (they float above Klaviyo)
 * No MutationObserver: the JS part runs on Klaviyo's own klaviyoForms events plus a few short retries.
 */
(function () {
  'use strict';
  var FID = (window.__fhKlPopup && window.__fhKlPopup.formId) || '';
  if (!/^[A-Za-z0-9]{6}$/.test(FID) || window.__fhKlA2Style) return;
  window.__fhKlA2Style = true;
  var F = 'form[data-testid="klaviyo-form-' + FID + '"]';
  var scopes = ['div[role="dialog"]:has(' + F + ')', 'div[role="dialog"].fh-kl-a2'];
  var outer = function (S) {
    return S + '{background-color:#404040!important}' +
      S + ' button.klaviyo-close-form svg circle{fill:#fff;stroke:#fff}' +
      S + ' button.klaviyo-close-form svg path{stroke:#404040;stroke-width:1.6px}';
  };
  // third-party floating widgets (Freshchat bubble, Google Customer Reviews badge) sit above Klaviyo's z-index;
  // hide them only while this form's dialog is on screen so no page UI shows over the full-screen form
  // FH 2026-10-02: the hiding is now tied only to the "open" class. Klaviyo leaves a hidden copy of the form in
  // the page after the pop-up closes (it holds the teaser), so the old html:has(form) rule kept the Google badge
  // and the chat button hidden for the rest of the visit. The "Get 15% Off" teaser is hidden too: the offer is
  // 5%, and it sat on top of the Google badge (teasers were removed on purpose on 2026-09-26).
  var W = ' #freshdeskwidgetcontainer, #freshdeskicon, #fc_frame, #___ratingbadge_0, [id^="___ratingbadge"]';
  var widgets = function (S) { return S + W.split(',').join(',' + S) + '{display:none!important}'; };
  var css = scopes.map(outer).join('\n') +
    widgets('html.fh-kl-a2-open') +
    '[class*="kl-teaser-' + FID + '"]{display:none!important}' +
    F + '>div>div:first-child{padding:56px clamp(24px,5vw,72px)!important;box-sizing:border-box!important;min-width:0!important}' +
    F + ' a{text-decoration:underline!important;text-underline-offset:2px}' +
    F + ' input,' + F + ' button{max-width:100%!important;box-sizing:border-box!important}' +
    '@media (max-width:640px){' +
      F + '>div>div:first-child{width:100%!important;max-width:100%!important;flex:1 1 auto!important;padding:72px 20px 32px!important}' +
      F + '>div>div:nth-child(2){display:none!important}' +
    '}';
  var st = document.createElement('style');
  st.id = 'fh-kl-a2-style';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  function apply() {
    var form = document.querySelector(F);
    if (!form) return false;
    var dlg = form.closest('[role="dialog"]');
    if (dlg) dlg.classList.add('fh-kl-a2');
    document.documentElement.classList.add('fh-kl-a2-open');
    var imgs = form.querySelectorAll('.klaviyo-form-image img:not([alt])');
    for (var i = 0; i < imgs.length; i++) imgs[i].setAttribute('alt', '');
    return true;
  }
  window.addEventListener('klaviyoForms', function (e) {
    var d = e && e.detail;
    if (!d || String(d.formId) !== FID) return;
    if (d.type === 'close') { document.documentElement.classList.remove('fh-kl-a2-open'); return; }
    if (d.type === 'open' || d.type === 'viewedStep' || d.type === 'stepSubmit' || d.type === 'submit') {
      [0, 60, 250, 800, 2000].forEach(function (ms) { setTimeout(apply, ms); });
    }
  });
})();
/* FH-2026-09-26 KLAVIYO POPUP FULLSCREEN + A11Y END */
/* FH-2026-09-26 KLAVIYO POPUP TRIGGER END */
